'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incrementUnseenCount = exports.incrementUnseenCountAction = undefined;

var _reduxActions = require('redux-actions');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _calculateUnseenThreadsCount = require('../../threads/selectors/calculateUnseenThreadsCount');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _postUnreadConversationCountChangedEvent = require('../../threads/actions/postUnreadConversationCountChangedEvent');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var incrementUnseenCountAction = exports.incrementUnseenCountAction = (0, _reduxActions.createAction)(ActionTypes.INCREMENT_UNSEEN_COUNT);

var incrementUnseenCount = exports.incrementUnseenCount = function incrementUnseenCount(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });
    var originalUnseenCountForThread = (0, _threadGetters.getUnseenCount)(thread);

    dispatch(incrementUnseenCountAction({ channel: channel, threadId: threadId }));

    if (originalUnseenCountForThread === 0) {
      var newUnreadThreadsCount = (0, _calculateUnseenThreadsCount.calculateUnseenThreadsCount)(getState());

      dispatch((0, _postUnreadConversationCountChangedEvent.postUnreadConversationCountChangedEvent)({
        unreadCount: newUnreadThreadsCount
      }));
    }
  };
};